import { InjectionToken } from '@angular/core';
import { MaterialCssVariablesConfig } from 'angular-material-css-vars';

export const MATERIAL_CSS_VARS_CFG = new InjectionToken<MaterialCssVariablesConfig>('Mat Css Config');
